import { Navigate, useSearchParams } from "react-router";

function getRedirectParams(searchParams: URLSearchParams) {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    return params;
}

function handleDashboardProductPage(sanitizedParams: URLSearchParams) {
    const params = new URLSearchParams(sanitizedParams);
    const codename = params.get("codename");
    const version = params.get("version");

    if (codename && version) {
        return <Navigate to={"/dashboard/products/" + codename + "/" + version} replace />;
    }

    return <Navigate to={"/dashboard/products?" + params.toString()} replace />;
}

function handleAccountSecurityPage(sanitizedParams: URLSearchParams) {
    const params = new URLSearchParams(sanitizedParams);
    params.set("tab", "security");
    return <Navigate to={"/account/settings?" + params.toString()} replace />;
}

function handlePasswordChangePage(sanitizedParams: URLSearchParams) {
    const params = new URLSearchParams(sanitizedParams);
    params.set("tab", "security");
    params.set("mode", "password");
    return <Navigate to={"/account/settings?" + params.toString()} replace />;
}

export const RedirectService = () => {
    const [searchParams] = useSearchParams();
    const sanitizedParams = getRedirectParams(searchParams);

    const page = searchParams.get("page");
    switch (page) {
        case "accountConfirmation":
            return <Navigate to={"/account/confirm?" + sanitizedParams.toString()} replace />;
        case "accountSecurity":
            return handleAccountSecurityPage(sanitizedParams);
        case "invitation":
            return <Navigate to={"/invitation?" + sanitizedParams.toString()} replace />;
        case "login":
            return <Navigate to={"/login?" + sanitizedParams.toString()} replace />;
        case "logout":
            return <Navigate to={"/logout?" + sanitizedParams.toString()} replace />;
        case "passwordChange":
            return handlePasswordChangePage(sanitizedParams);
        case "passwordRecover":
            return <Navigate to={"/account/recover?" + sanitizedParams.toString()} replace />;
        case "passwordReset":
            return <Navigate to={"/account/reset?" + sanitizedParams.toString()} replace />;
        case "product":
            return handleDashboardProductPage(sanitizedParams);
        default:
            return <Navigate to="/" replace />;
    }
};
